import { sanitizeTooltip } from '__core/shared/util/transform';

/* @ngInject */

export default ($rootScope, $timeout, $mdToast) => {
  /**
   * Apply function to scope.
   *
   * @param {Function} func - HTML Element.
   * @param {Number} [delay] - Delay in milliseconds.
   */
  const scopeApply = (func, delay) => {
    $timeout(() => {
      $rootScope.$apply(func);
    }, delay || 0);
  };

  /**
   * Scroll content(s) of HTML element.
   *
   * @param {String} el - HTML Element.
   */
  const elementContentScroll = (el) => {
    scopeApply(() => {
      const htmlElement = document.getElementById(el);
      if (htmlElement && htmlElement.scrollHeight) {
        htmlElement.scrollTop = htmlElement.scrollHeight;
      }
    });
  };

  /**
   * Display toast on page.
   *
   * @param {Object} params
   * @param {Object} [params.user]
   * @param {String} [params.user.avatar]
   * @param {String} [params.user.name]
   * @param {Object} params.text
   * @param {String} params.text.p1
   * @param {String} params.text.p2
   * @param {String} params.text.p3
   * @param {String} [params.text.p4]
   * @param {Boolean} [params.progress]
   * @param {String} [params.action]
   * @param {Boolean} [params.warn]
   * @param {Boolean} [params.success]
   * @param {Number} [params.delay]
   */
  const toast = (params) => {
    if (params) {
      let template = '';
      template += '<md-toast><span class="md-toast-text" flex>';
      if (params?.user) {
        template += '<span>';
        if (params?.user.avatar) {
          template += `<img src="${params?.user.avatar}" class="avatar">`;
        }
        if (params?.user.name) {
          template += `<md-tooltip>${sanitizeTooltip(params?.user.name)}</md-tooltip>`;
        }
        template += '</span>';
      }
      if (params?.text) {
        if (params?.text?.p1) {
          template += `<span class="grey-200 mr1">${sanitizeTooltip(params?.text?.p1)}</span>`;
        }
        if (params?.text?.p2) {
          template += `<span class="${
            params?.success ? 'green-500' : 'grey-500'
          } mr1">${sanitizeTooltip(params?.text.p2)}</span>`;
        }
        if (params?.text?.p3) {
          template += `<span class="${
            params?.warn ? 'red-500' : 'grey-200'
          } mr1">${sanitizeTooltip(params?.text?.p3)}</span>`;
        }
        if (params?.text?.p4) {
          template += `<span class="${
            params?.warn ? 'red-500' : 'grey-500'
          } mr1">${sanitizeTooltip(params?.text?.p4)}</span>`;
        }
      }
      if (params?.progress) {
        template +=
          '<md-progress-linear class="mt1" md-mode="indeterminate"></md-progress-circular>';
      }
      template += '</span>';
      if (params?.action) {
        template += `<md-button class="ml5 mr0" ng-click="toastAction()">${sanitizeTooltip(
          params?.action
        )}</md-button>`;
      }
      template += '</md-toast>';

      return $mdToast.show({
        template,
        controller($scope) {
          $scope.toastAction = function () {
            $mdToast.hide(true);
          };
        },
        position: 'bottom center',
        hideDelay: params?.delay || params?.warn ? 5000 : 3500
      });
    }
    return null;
  };

  return {
    elementContentScroll,
    scopeApply,
    toast
  };
};
